import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaPaymentConfirmationData } from "@/src/types/admissionOffice";
import type { AdmissionOfficeCountry } from "../../admissionOfficeCountry";

const emptyState = (): AOPMaltaPaymentConfirmationData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  payment_header: [],
  payment_footer: [],
});

export interface AOPPaymentConfirmationBasicLayoutProps {
  country: AdmissionOfficeCountry;
}

const AOPPaymentConfirmationBasicLayout = ({ country }: AOPPaymentConfirmationBasicLayoutProps) => {
  const [isPrevReady, setIsPrevReady] = useState(false);
  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaPaymentConfirmationData>(emptyState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaPaymentConfirmationData>(emptyState);
  const [withQR, setWithQR] = useState(true);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        country={country}
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setIsPrevReady={setIsPrevReady}
        setWithQRForPreview={setWithQR}
      />
      <AOPPrev country={country} bodyForPrev={bodyForPrev} isPrevReady={isPrevReady} withQR={withQR} />
    </div>
  );
};

export default AOPPaymentConfirmationBasicLayout;
